import React from 'react'
import { NewTable } from '../../../../../components';
import { mapTableRows } from '../../../../../utils';

const CreatedInvoives = () => {


  const columns = [
    {
      key: "InvoiceNumber",
      label: "Invoice Number",
    },

    {
      key: "employee",
      label: "Employee",
    },

    {
      key: "employeeid",
      label: "Employee ID",
    },
    {
      key: "employee Type",
      label: "Employee Type",
    },
    {
      key: "Client",
      label: "Client",
    },
    {
      key: "Clientid",
      label: "Client ID",
    },
    {
      key: "InvoiceDate",
      label: "Invoice Date",
    },
 
    {
      key: "ShippedeDate",
      label: "Shipped Date",
    },
    {
      key: "CreatedOn",
      label: "Created On",
    },
    {
      key: "Action",
      label: "Action",
    },
 
  ];
  const tableData = [];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
    <NewTable
      rows={mappedRows}
      columns={columns}
      toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
    />
  </div>
  )
}

export default CreatedInvoives